<template>
    <div id="app-player-container">
      <section id="player-section">
        <section id="video-player-section">
          <app-player class="col-md-8" 
          :videoWebM="playerInfo.url.webm"
          :videoOgg="playerInfo.url.ogg"
          :videoMp4="playerInfo.url.mp4"
          :videoTitle="playerInfo.title"
          :thumbnail="playerInfo.thumbnail"
          ref="playerContainer"></app-player>
        </section>
        <section id="playlist-section">
          <app-playlist class="col-md-4"
          :playlistArr="wipoVideoPlaylist" 
          :selected="playerInfo.title"
          :selectURL="playerInfo.url.mp4"
          :defaultHeight="playerHeight"
          @selectNewVideo="changeVideo"
          @selectNewThumbnail="changeThumbnail"></app-playlist> 
        </section>
      </section>
    </div>
</template>

<script>
import axios from 'axios'
import Player from './components/Player'
import Playlist from './components/Playlist'

export default {
  data () {
    return {
      playerInfo : {
        title : 'Coming September 2: Global Innovation Index 2020',
        thumbnail : "./src/assets/thumb-1.jpg",
        url : {
            ogg : "",
            mp4 : "",
            webm : ""
        }
      },
      info : [],
      playerHeight : 650,
      app : {
        innerWidth : ('#main-player-container').innerWidth
      },
    }
  },
  mounted() {
    this.assignDefault(this.wipoVideoPlaylist)
  },
  computed :  {
    wipoVideoPlaylist() {
      let videoList = JSON.parse(sessionStorage.getItem("wipoPlaylist"))
      return videoList
    }
  },
  watch : {
    info : function(){
      this.playerInfo.url.mp4 = this.info[0].url.mp4;
      this.playerInfo.url.ogg = this.info[0].url.ogg;
      this.playerInfo.url.webm = this.info[0].url.webm;
      this.playerInfo.thumbnail = this.info[0].thumbnail;
    }
  },
  methods : {
    assignDefault(e) {
      let value = {
            mp4 : e[0].url.mp4,
            ogg : e[0].url.ogg,
            webm : e[0].url.webm,
          }
      this.changeVideo(value)
    },
    updatePlaylistHeight() {
      this.playerHeight = this.$refs.playerContainer.clientHeight
    },
    changeVideo(value) {
      this.playerInfo.url.mp4 = value.mp4
      this.playerInfo.url.ogg = value.ogg
      this.playerInfo.url.webm = value.webm
    },
    changeThumbnail(value) {
      this.playerInfo.thumbnail = value
    },
    loadDefaultHeight() {
      
    },
    resizeHeight() {
        if(window.innerWidth <= 425){
          return 450
        }
        if(window.innerWidth >= 768 &&  window.innerWidth <= 1024){
          return 300;
        }
        return 435
    }
  },
  components : {
    appPlayer : Player,
    appPlaylist : Playlist
  }
}
</script>

<style scoped>  
  #player-section{
    display: flex;
    justify-content: space-between;
  }
  #video-player-section{
    width: 63%;
  }
  #playlist-section{
    width: 36%;
  }
  #main-player-container{
    width:60%;
  }
  #app-player-container{
    max-width: 1020px;
    margin:0 auto 0 auto;
    display: block;
  }
  #video-header-section{
    color:#fff;
    font-family:Arial, Helvetica, sans-serif
  }
  #video-header-section {
    padding:20px 20px 0 20px;
    display: block;
  }
  #video-header-section #video-header h3{
    font-family: Arial, Helvetica, sans-serif;
    font-weight: bold;
    font-size: 20px;
    color: #fff;
  }
  #player-section{
    display: flex;
  }
  #video-header-section .video-links a{
    font-family: Arial, Helvetica, sans-serif;
    color:#fff;
    font-weight: bold;
    font-size:14px;
  }
  @media only screen and (min-width:768px) and (max-width:1025px;){
    #video-player-section{
      width: 55%;
    }
    #playlist-section{
      width: 44%;
    }
  }
  @media only screen and (max-width: 767px){ 
    #player-section{
      display: block;
      padding: 0;
    }
    #video-player-section{
      width: 100%;
    }
    #playlist-section{
      width: 100%;
    }
  }
  
</style>



// WEBPACK FOOTER //
// src/App.vue